import React, { useEffect, useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

const FilterDateTimeRange = ({
  field_name,
  selectedItems,
  setSelectedItems,
  addNode,
  removeNode,
  updateNode,
  path,
  pathExists,
}) => {
  const [fromDate, setFromDate] = useState(selectedItems[field_name]?.from || null);
  const [toDate, setToDate] = useState(selectedItems[field_name]?.to || null);

  const fullPath = [...path, { key: field_name, value: 0 }];

  const handleFromDateClose = () => {
    processNodeChanges();
  };

  const handleToDateClose = () => {
    processNodeChanges();
  };

  const processNodeChanges = () => {
    const fromTimestamp = fromDate ? fromDate.toDate().getTime() : null;
    const toTimestamp = toDate ? toDate.toDate().getTime() : null;

    if (fromDate && toDate) {
      // When both dates are set, add or update the node
      if (pathExists(fullPath)) {
        updateNode(fullPath, { is_group: 0, min: fromTimestamp, max: toTimestamp }, field_name);
      } else {
        addNode(fullPath, { is_group: 0, min: fromTimestamp, max: toTimestamp });
      }
      setSelectedItems((prev) => ({
        ...prev,
        [field_name]: { from: fromDate, to: toDate },
      }));
    } else if ((!fromDate || !toDate) && pathExists(fullPath)) {
      // Only remove the node if the path exists and either date is cleared
      removeNode(fullPath);
      setSelectedItems((prev) => {
        const { [field_name]: _, ...rest } = prev; // Destructure to omit `field_name`
        return rest; // Return the updated object without `field_name`
      });
    }
  };

  const handleFromDateChange = (newValue) => {
    setFromDate(newValue);
  };

  const handleToDateChange = (newValue) => {
    setToDate(newValue);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        label="From"
        value={fromDate}
        maxDateTime={toDate}
        onChange={handleFromDateChange}
        onClose={handleFromDateClose} // Process changes on close
        slotProps={{
          textField: {
            size: 'small',
            sx: {
              '& .MuiOutlinedInput-root': {
                border: '1px solid #B4B4B4',
                color: '#000',
                fontFamily: 'Sfpro400',
                fontSize: '12px',
                letterSpacing: '1.26px',
                outline: 'unset',
                width: '100%',
                padding: '0px 5px',
                borderRadius: '5px',
              },
              '& .MuiInputLabel-root': {
                fontSize: '14px',
              },
            },
          },
        }}
      />
      <DateTimePicker
        label="To"
        value={toDate}
        minDateTime={fromDate}
        onChange={handleToDateChange}
        onClose={handleToDateClose} // Process changes on close
        slotProps={{
          textField: {
            size: 'small',
            sx: {
              '& .MuiOutlinedInput-root': {
                border: '1px solid #B4B4B4',
                color: '#000',
                fontFamily: 'Sfpro400',
                fontSize: '12px',
                letterSpacing: '1.26px',
                outline: 'unset',
                width: '100%',
                padding: '0px 5px',
                borderRadius: '5px',
              },
              '& .MuiInputLabel-root': {
                fontSize: '14px',
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default FilterDateTimeRange;
